var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/**
 * @author: Richard Scoones @ 1/5/2019
 * @description: Token setting service. Currently uses legacy method too.
 */
import API from "@irati/utils/services/API";
import { get } from "lodash";
import { store } from "@irati/store";
import endpoints from "../endpoints";
import { getAllApps } from "./apps";
import getSessionId from "../helpers/getSessionId";
var KEY = "keys";
var ENCRYPTED_KEY = "accessToken";
var TokenStorage = /** @class */ (function () {
    function TokenStorage() {
    }
    TokenStorage.prototype.resume = function () {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                clearLegacyTokens();
                if (!API.hasTokens()) {
                    return [2 /*return*/, fetchTokens().then(function (_a) {
                            var accessToken = _a.accessToken;
                            var auth = store.getState().auth;
                            if (accessToken) {
                                API.setTokens(accessToken);
                            }
                            var sessionId = getSessionId(accessToken);
                            return { apps: getAllApps(__assign(__assign({}, auth), { accessToken: accessToken })), sessionId: sessionId };
                        })];
                }
                return [2 /*return*/, store.getState().auth];
            });
        });
    };
    TokenStorage.prototype.hasResumed = function () {
        return true;
    };
    TokenStorage.prototype.set = function (tokens) {
        clearLegacyTokens();
        API.setTokens(tokens.accessToken);
        var config = { addCSRF: true, useErrorHandler: false, sentryIgnoreAllErrors: true };
        return API.post(endpoints.setCredentials(), tokens, config).then(function (res) {
            setEncryptedToStorage(res.data.encrypted);
            return true;
        });
    };
    TokenStorage.prototype.clear = function () {
        localStorage.removeItem(KEY);
        sessionStorage.removeItem(KEY);
        API.clearTokens();
        clearRemoteTokens();
    };
    return TokenStorage;
}());
export default new TokenStorage();
function fetchTokens() {
    var encrypted = getFromStorage(ENCRYPTED_KEY);
    var config = { addCSRF: true, useErrorHandler: false, sentryIgnoreAllErrors: true };
    return API.post(endpoints.getCredentials(), { encrypted: encrypted }, config)
        .catch(function () { })
        .then(function (res) {
        var tokens = get(res, "data");
        return tokens;
    });
}
function clearRemoteTokens() {
    var config = { addCSRF: true, useErrorHandler: false, sentryIgnoreAllErrors: true };
    return API.post(endpoints.setCredentials(), {}, config)
        .catch(function () { })
        .then(function () { return true; });
}
function getFromStorage(key) {
    var item = localStorage.getItem(key);
    if (!item) {
        item = sessionStorage.getItem(key);
    }
    return item;
}
function setEncryptedToStorage(encrypted) {
    localStorage.setItem(ENCRYPTED_KEY, encrypted);
}
function clearLegacyTokens() {
    localStorage.removeItem(KEY);
    sessionStorage.removeItem(KEY);
}
